import React, { useState, useEffect } from 'react';

// custom components 
import { } from '_atoms';
import { BatterySelector } from "_molecules";

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// styles 
import { Colors } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectBookingForm, setBookingForm } from '_redux/slices/assistance-bookings/booking-form';

const WheelchairInformation = (props) => {

    // manual states
    const [manual, setManual] = useState(false);
    const [manualPower, setManualPower] = useState(false);

    // redux
    const bookingForm = useSelector(selectBookingForm);
    const dispatch = useDispatch();

    // errors
    const [errors, setErrors] = useState({});

    //#region set handlers
    const setBattery = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {battery: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setModel = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {model: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setMake = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {make: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setWeight = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {weight: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setWidth = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {width: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setHeight = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], {height: value});        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    //#endregion

    return (
        <>
        { props.show && 
            <Form.Group>

                {/* Battery & Model */}
                <Row>
                    <Col xs={12} md>
                        <Row>
                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Battery {manualPower ? '(Optional)' : ''}</Form.Label>
                            <Container>
                                <BatterySelector setList={(list) => {setBattery(list)}} defaultValue={bookingForm[props.index].battery} value={bookingForm[props.index].battery}/>
                                    {
                                        errors.battery && (
                                            <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.battery}</p>
                                        )
                                    }
                            </Container>
                        </Row>
                    </Col>
                    <Col xs={12} md className="mt-3 mt-md-0">
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{ manualPower ? 'Model (Optional)' : 'Model'}</Form.Label>
                        <Form.Control onChange={(e) => {setModel(e.target.value)}} type="name" placeholder="Enter equipment model" value={bookingForm.model} defaultValue={bookingForm.model} />
                        {
                            errors.model && (
                                <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.model}</p>
                            )
                        }
                    </Col>
                </Row>

                {/* Height & Width */}
                <Row className="mt-3">
                    <Col xs={12} md>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Height (Collapsed) {manualPower ? '(Optional)' : ''}</Form.Label>
                        <Form.Control onChange={(e) => {setHeight(e.target.value)}} type="name" placeholder="Enter equipment height" value={bookingForm[props.index].height} defaultValue={bookingForm[props.index].height} />
                        {
                            errors.height && (
                                <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.height}</p>
                            )
                        }
                    </Col>
                    <Col xs={12} md className="mt-3 mt-md-0">
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Width (Collapsed) {manualPower ? '(Optional)' : ''}</Form.Label>
                        <Form.Control onChange={(e) => {setWidth(e.target.value)}} type="name" placeholder="Enter equipment width" value={bookingForm[props.index].width} defaultValue={bookingForm[props.index].width} />
                        {
                            errors.width && (
                                <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.width}</p>
                            )
                        }
                    </Col>
                </Row>
                
                {/* Weight & Make */}
                <Row>
                    <Col xs={12} md>
                        <Row className="mt-3">
                            <Form.Label style={{color: Colors.PRM_LIGHT_BLUE }}>Weight (kg) {manualPower ? '(Optional)' : ''}</Form.Label>
                            <Container>
                                <Form.Control onChange={(e) => {setWeight(e.target.value)}} type="name" placeholder="Enter equipment weight" value={bookingForm[props.index].weight} defaultValue={bookingForm[props.index].weight} />
                                    {
                                        errors.weight && (
                                            <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.weight}</p>
                                        )
                                    }
                            </Container>
                        </Row>
                    </Col>
                    <Col xs={12} md>
                        <Row className='mt-3'>
                            <Form.Label style={{color: Colors.PRM_LIGHT_BLUE}}>Make {manualPower ? '(Optional)' : ''}</Form.Label>
                            <Form.Control onChange={(e) => {setMake(e.target.value)}} type="name" placeholder="Enter equipment make" value={bookingForm[props.index].make} defaultValue={bookingForm[props.index].make} />
                            {
                                errors.make && (
                                    <p style={{color:Colors.TEXT_COLOR}} className="text-danger">{errors.make}</p>
                                )
                            }
                        </Row>
                    </Col>
                </Row>
            </Form.Group>
        }
        </>
    );
};

export default WheelchairInformation;
